<template>
        <v-dialog v-model="mainDialog" max-width="1250px" persistent>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            color="primary"
                            dark
                            class="ma-2" small 
                            v-bind="attrs"
                            v-on="on"
                            
                            ><v-icon>mdi-plus</v-icon>เบิก</v-btn>
                        </template>
    <v-card tile>
            <v-card-title>เบิกวัสดุสิ้นเปลือง</v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-form ref="form" v-model="valid" lazy-validation>
                <v-row class="mx-2">
                    <v-col cols="3"><DatePicker @dateFormatted="setWidthdrawDate" label="วันที่"> </DatePicker></v-col>
                    <v-spacer></v-spacer>
                    <v-col><v-text-field v-model="mainData.stockOfficer" outlined placeholder=" " label="ผู้ที่เบิก"></v-text-field></v-col>
                   <!-- <v-col><v-text-field autofocus  :rules="[rules.required]"  v-model="mainData.withdrawNo" outlined placeholder=" " label="เลขที่ใบเบิกวัสดุสิ้นเปลืองในสำนักงานสาขา"></v-text-field></v-col> -->
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                        :headers="header"
                        :items="mainData.details"
                        style="border:0.2px solid; border-color:#909090"
                        >
                        <template v-slot:top>
                             <v-toolbar flat color="white">
                                 <v-toolbar-title>ข้อมูลวัสดุสิ้นเปลือง</v-toolbar-title>
                             </v-toolbar>
                             <v-divider
                                    class="mx-4"
                                    inset
                                    ></v-divider>
                             <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                                    <v-row class="mx-2">
                                        <v-col>
                                            <v-autocomplete
                                                autofocus
                                                v-model="selectedConsumable"
                                                outlined 
                                                placeholder="พิมพ์รหัส หรือ ชื่อวัสดุสิ้นเปลือง"
                                                :items="consumableList"
                                                return-object
                                                item-text="consumableDisplay"
                                                item-value="consumableCode"
                                                :rules="[rules.requiredConsumable]"
                                                label="วัสดุสิ้นเปลือง">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="2"><v-text-field :rules="[rules.requiredMinMaxNumber(1, detail.stockRemain)]"  v-model="detail.qty" outlined placeholder=" " label="จำนวน" maxlength="4" v-mask="'####'"></v-text-field></v-col>
                                        <v-col cols="2"><v-text-field :rules="[rules.requiredNumber]" v-model="detail.unitPrice" outlined placeholder=" " label="ราคา/หน่วย"></v-text-field></v-col>
                                        <v-col cols="2"><v-text-field disabled :rules="[rules.requiredNumber]" v-model="detail.stockRemain" outlined placeholder=" " label="คงเหลือใน Stock"></v-text-field></v-col>
                                        <v-col cols="2">
                                            <v-btn class="ma-2" color="primary" @click="saveDetail">เพิ่ม</v-btn>
                                            <v-btn class="ma-2" color="primary" @click="closeDialog"> ล้าง</v-btn>
                                        </v-col>
                                    </v-row>
                            </v-form> 
                        </template>
                             <template v-slot:item.action="{ item }">
                                <v-icon
                                    small
                                    @click="deleteDetail(item)"
                                >
                                    delete
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                 <v-row>
                    <v-col cols="6">
                        <v-data-table
                        :headers="headerSummary"
                        :items="itemSummary"
                        style="border:0.2px solid; border-color:#909090"
                        hide-default-footer
                        >
                        </v-data-table>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex align-end align-center">
                        <v-btn style="margin-right:10px;" color="primary" @click="save">บันทึก</v-btn>&nbsp;
                        <v-btn color="primary"  @click="close">ยกเลิก</v-btn>
                    </v-col>
                </v-row>
                </v-form>
                
            </v-container>
            
        </v-card>
        </v-dialog>
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {insertStockConsumable} from '@/api/stock/stock-consumable-api.js'
import {listDropdownConsumableType} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'
import rules from '@/assets/js/rules.js'

export default {
    name: 'AddStockConsumableOffice',
    props: ["branchCode"],
    components: {
        DatePicker
    },
    watch: {
        selectedConsumable(val) {
            this.detail.unitPrice = numeral(val.unitPrice).format('0.00');
            this.detail.unitPriceDisplay = numeral(val.unitPrice).format('0,0.00');
            this.detail.stockRemain = numeral(val.stockRemain).format('0,0.00');
            this.detail.size = val.size;
        },
        mainDialog(val) {
            this.selectedConsumable = {};
            this.mainData = Object.assign({}, this.defaultMainData);
            this.mainData.details =  Object.assign([], []);
            this.detail = Object.assign({}, this.defaultDetail);
            if (val) {
                this.listConsumableData();
                this.resetSummary();
            }
        }
    },
    data: () => ({
        mainDialog: false,
        rules: rules,
        valid: false,
        validDetail: false,
        header: [
            {text: 'หมายเลขวัสดุ', value: 'consumableCode', class: 'indigo--text'},
            {text: 'ชื่อรายการวัสดุ', value: 'consumableName', class: 'indigo--text'},
            {text: 'จำนวน', value: 'qty', class: 'indigo--text'},
            {text: 'ราคา/หน่วย', value: 'unitPrice', class: 'indigo--text'},
            {text: 'ยอดรวม', value: 'amount', class: 'indigo--text'},
            {text: 'รวมสุทธิ', value: 'netAmount', class: 'indigo--text'},
            {text: 'Actions', value: 'action', sortable: false, class: 'indigo--text'}
        ],
        mainData: {
            branchCode: '',
            withdrawNo: '',
            docDate: '',
            withdrawDate: '',
            stockOfficer: '',
            details: []
        },
        defaultMainData: {
            branchCode: '',
            withdrawNo: '',
            docDate: '',
            withdrawDate: '',
            stockOfficer: '',
            details: []
        },
        detail: {
                consumableCode: '',
                consumableName: '',
                unitPrice: '',
                qty: '',
                amount: '',
                netAmount: '',
                remark: '',
                stockRemain: '',
                size: ''
        },
        defaultDetail: {
                consumableCode: '',
                consumableName: '',
                unitPrice: '',
                qty: '',
                amount: '',
                netAmount: '',
                remark: '',
                stockRemain: '',
        },
        headerSummary: [
            {text: '', value: 'sumType'},
            {text: 'ยอดรวม', value: 'amountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'netDisplay'}
        ],
        itemSummary: [
        ],
        consumableList: [],
        selectedConsumable: {},
        summary: {
            sum: {
                sumType: 'รวม',
                amount: 0,
                net: 0,
                amountDisplay: 0,
                netDisplay: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                net: 0,
                amountDisplay: 0,
                netDisplay: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                net: 0,
                amountDisplay: 0,
                netDisplay: 0
            }
        }
    }),
    methods: {
        setWidthdrawDate(val) {
            this.mainData.withdrawDate = val;
        },
        deleteDetail(item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return;
            }
            this.selectedConsumable = {};
            let index = this.mainData.details.indexOf(item);
            this.mainData.details.splice(index, 1);

            let consumables = this.consumableList.filter(o => o.consumableCode == item.consumableCode);
            if (!consumables || consumables.size <= 0) return;
            consumables[0].stockRemain += parseInt(item.qty);
            this.removeSummary(item);
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            this.setDetailData();
            this.calculateSummary();
            this.closeDialog();
        },
        setDetailData() {
            this.detail.consumableCode = this.selectedConsumable.consumableCode;
            this.detail.consumableName = this.selectedConsumable.consumableName;
            //this.detail.unitPrice = this.selectedConsumable.unitPrice;
            this.detail.amount = this.detail.qty * this.detail.unitPrice;
            this.detail.netAmount = this.detail.amount;
            this.setDetailDisplay(this.detail);
            this.mainData.details.push(this.detail);
            let consumables = this.consumableList.filter(o => o.consumableCode == this.selectedConsumable.consumableCode);
            if (!consumables || consumables.size <= 0) return;
            consumables[0].stockRemain -= parseInt(this.detail.qty);
        },
        setDetailDisplay(detail) {
            detail.amount = numeral(detail.amount).format('0.00');
            detail.netAmount = numeral(detail.netAmount).format('0.00');
            detail.unitPriceDisplay = numeral(detail.unitPrice).format('0,0.00');
            detail.amountDisplay = numeral(detail.amount).format('0,0.00');
            detail.netAmountDisplay = numeral(detail.netAmount).format('0,0.00');
        },
        removeSummary(item) {
            this.summary.sum.amount -= item.amount;
            this.summary.sum.net -= item.netAmount;
            this.calculateSummary();
        },
        resetSummary() {
            this.summary.sum.amount = 0;
            this.summary.sum.net = 0;

            this.summary.vat.amount = 0;
            this.summary.vat.net = 0;

            this.summary.total.amount = 0;
            this.summary.total.net = 0;
            
        },
        calculateSummary() {
            this.summary.sum.amount += this.detail.amount;
            this.summary.sum.net += this.detail.netAmount;
            this.setSumDisplay(this.summary.sum);

            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;
            this.setSumDisplay(this.summary.vat);

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;
            this.setSumDisplay(this.summary.total);
        },
        setSumDisplay(obj) {
            obj.amountDisplay = numeral(obj.amount).format('0,0.00');
            obj.netDisplay = numeral(obj.net).format('0,0.00');
        },
        closeDialog() {
            this.selectedConsumable = Object.assign({}, {});
            this.detail = Object.assign({}, this.defaultDetail);
        },
        close() {
            this.mainData = Object.assign({}, this.defaultMainData);
            this.mainData.details =  Object.assign([], []);
            this.detail = Object.assign({}, this.defaultDetail);
            this.resetSummary();
            this.mainDialog = false;
            this.$emit("close");
        },
        save() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.mainData.branchCode = this.branchCode;
            this.$loading(true);
            insertStockConsumable(this.mainData).then( () => {
                this.$loading(false);
                this.close();
            }).catch( () => {
                this.$loading(false);
            });
        },
        listConsumableData() {
            listDropdownConsumableType('AOD', this.branchCode, true).then(rs => {
                this.consumableList = rs;
            })
        }
    },
    mounted() {
        this.itemSummary.push(this.summary.sum);
        this.itemSummary.push(this.summary.vat);
        this.itemSummary.push(this.summary.total);
    }
}
</script>
